import { useQuery } from '@sequencehq/api'
import {
  dashboard20240730Client,
  DashboardApi20240730
} from '@sequencehq/api/dashboard/v20240730'
import { isMilestoneScheduleEndDate } from '@sequencehq/utils'
import { format, MINUTES } from '@sequencehq/utils/dates'
import { useMemo } from 'react'

const API_DATE_FORMAT = 'yyyy-MM-dd'

export type AmendableSchedule =
  DashboardApi20240730.GetBillingSchedule.BillingSchedule

type UseAmendableSchedules = (args: { customerId: string }) => {
  schedules: AmendableSchedule[]
  isLoading: boolean
}

export const useAmendableSchedules: UseAmendableSchedules = ({
  customerId
}) => {
  const response = useQuery(
    dashboard20240730Client.getBillingSchedules,
    {
      customerId,
      billingScheduleStatus: 'ACTIVE',
      limit: 100
    },
    {
      enabled: Boolean(customerId),
      staleTime: 1 * MINUTES,
      select: res => res?.items ?? []
    }
  )

  const today = format(new Date(), API_DATE_FORMAT)

  const schedules = useMemo(
    () =>
      (response.data ?? [])
        .filter(schedule => !isMilestoneScheduleEndDate(schedule.endDate ?? ''))
        .filter(schedule => schedule.startDate <= today)
        .sort((a, b) => a.startDate.localeCompare(b.startDate)),
    [response.data, today]
  )

  return { schedules, isLoading: response.isLoading }
}
